/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

import React from "react";

const SignalFilter = ({ onTagSelect }) => {
  const tags = ["options", "intraday", "trend", "volatility", "oi"];

  return (
    <div style={styles.sidebar}>
      <h3>Filters</h3>

      {tags.map((t) => (
        <div key={t} style={styles.tag} onClick={() => onTagSelect(t)}>
          {t.toUpperCase()}
        </div>
      ))}

      <div style={styles.tag} onClick={() => onTagSelect(null)}>
        SHOW ALL
      </div>
    </div>
  );
};

const styles = {
  sidebar: {
    width: "200px",
    padding: "20px",
    borderRight: "1px solid #ddd",
  },
  tag: {
    padding: "10px",
    marginBottom: "8px",
    background: "#eee",
    cursor: "pointer",
    borderRadius: "4px"
  }
};

export default SignalFilter;
